
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/brokerFormReducers.reducers';

export const selectDataState = createFeatureSelector<State>('brokerFormConfigData');

export const selectBrokerFormConfigData = createSelector(selectDataState, (state) => state.brokerFormConfigData);
export const selectBrokerFormConfigLoading = createSelector(selectDataState, (state) => state.loading);
export const selectBrokerFormConfigError = createSelector(selectDataState, (state) => state.error);
